// extracted by mini-css-extract-plugin
export var body = "_k0-0";
export var sectionHeader = "_k0-4";
export var shortcutColumns = "_k0-2";
export var shortcutList = "_k0-1";
export var shortcutSection = "_k0-3";